import * as zod from 'zod';

export const HaasAddress = zod.object({
  kind: zod.literal('HaasEthernet'),
  // e.g. 172.20.201.16:5051/something
  endpoint: zod.string(),
});

export type HaasAddress = zod.infer<typeof HaasAddress>;
